import type { CurrencyCode } from 'app/api/services/site-configs/types';
import type { ReduxState } from 'app/redux/types';

import { accountCurrency } from 'app/lib/account/selectors';
import { siteCurrencyAbbr } from 'app/lib/site-configs/selectors';
import { selectIsLoggedIn } from 'app/redux/selectors/auth';


const selectCurrency = (state: ReduxState): CurrencyCode => {
  if (selectIsLoggedIn(state)) {
    return accountCurrency(state) || 'RUB';
  }
  return siteCurrencyAbbr(state);
};

export default selectCurrency;
